import { useMemo } from 'react';

import { useGrid } from '@Components/Grid';
import { keyOf } from '@Components/Grid/components/Table/formatters';
import column, { defaultActionsColumn, defaultColumn, defaultColumnId } from '@Components/Grid/utils/column';
import { mapping } from 'utils';

import DetailsEntity from './DetailsEntity';
import FileFormatter from './FileFormatter';
import SCAStatusFormatter from './SCAStatusFormatter';
import URLEntityFormatter from './URLEntityFormatter';
import WinnerFormatter from './WinnerFormatter';

export default function useColumns() {
  const { store: { lists: { posts: post, integrations: integration } } } = useGrid()

  post.useLoad(useMemo(() => ({ content_type: 'sweep' }), []))
  integration.useLoad()

  const posts = useMemo(() => post.items.reduce(mapping('id', 'title'), {}), [post.items])
  const integrations = useMemo(() => integration.items.reduce(mapping('id', 'description'), {}), [integration.items])

  return useMemo(() => [
    defaultColumnId(),
    column.accessor('integrationId', {
      header: 'Integration',
      cell: info => <URLEntityFormatter info={info} url='/settings/integrations' entities={integrations} />,
      size: 250,
    }),
    column.accessor('sweepId', {
      header: 'Sweep',
      cell: info => <URLEntityFormatter info={info} url='/cms/sweep' entities={posts} />,
      size: 250,
    }),
    defaultColumn('contestId', 'Contest'),
    column.accessor('status', {
      header: 'Status',
      cell: info => <SCAStatusFormatter info={info} />,
      size: 100,
    }),
    column.accessor('winnerFound', {
      header: 'Winner',
      cell: info => <WinnerFormatter info={info} />,
      size: 100,
    }),
    defaultColumn('ticketsCount', 'Entries', undefined, { size: 100 }),
    column.accessor('file.confirmed_count', {
      header: 'File Entries',
      cell: info => <FileFormatter info={info} />,
      enableSorting: false,
      size: 100,
    }),
    defaultActionsColumn(detailsAction),
  ], [posts, integrations])
}

function detailsAction(info) {
  return <DetailsEntity key={keyOf(info, 'details')} info={info} />
}
